import { useIntl } from "react-intl";
import { Occurrence } from "../../../models/occurrence";
import { IBudget } from "../../../models/budgetV2";

interface IBudgetVehicleCardProps {
    occurrence?: Occurrence | null;
    budget?: IBudget | null;
    loading: boolean;
}

const SkeletonBlock = ({ className = "" }: { className?: string }) => (
    <div className={`animate-pulse rounded bg-gray-300 ${className}`} />
);

export const BudgetVehicleCard = (props: IBudgetVehicleCardProps) => {

    const { occurrence, budget, loading } = props;

    const vehicleModel = occurrence?.vehicleModel ?? budget?.vehicleModel;
    const vehicleYear = occurrence?.vehicleYear;
    const vehicleLicensePlate = occurrence?.vehicleLicensePlate ?? budget?.vehicleLicensePlate;
    const vehicleChassis = occurrence?.vehicleChassis ?? budget?.vehicleChassis;
    const vehicleOdometer = occurrence?.vehicleOdometer ?? budget?.vehicleOdometer;
    const vehicleHourmeter = occurrence?.vehicleHourmeter ?? budget?.vehicleHourMeter;
    const contractNumber = occurrence?.contractNumber ?? budget?.vehicleContractNumber;
    const customer = occurrence?.customer ?? budget?.customerName;

    const intl = useIntl();

    return (
        <div className="flex flex-row gap-4 mb-6 px-6 items-stretch">
            <div className="flex-1 flex flex-col">
                <div className="mb-2 text-size-13 text-gray-600">{intl.formatMessage({ id: 'intl-msg:budgets.vehicle' })}</div>
                <div className="border border-gray-200 p-2 h-full mr-3 " style={{ backgroundColor: '#E5EBF0' }}>
                    <div className="rounded-md h-full" >
                        <div className="flex flex-row items-start">
                            <div className="bg-white flex items-center justify-center shrink-0 w-[50px] h-[70px] mr-5">
                                <img src="/assets/images/truck.svg" alt="Veículo" className="w-12 h-12" />
                            </div>
                            <div className="flex-1">
                                <div className="text-size-14">
                                    <div className="font-semibold text-size-13 text-gray-900">
                                        {loading ? <SkeletonBlock className="h-[10px] w-[200px] mb-4" /> : (
                                            [
                                                [vehicleModel, vehicleYear].filter(Boolean).join(' '),
                                                vehicleLicensePlate && `Placa: ${vehicleLicensePlate}`,
                                            ].filter(Boolean).join(' | ')
                                        )}
                                    </div>

                                    {loading ? <SkeletonBlock className="h-[10px] w-[200px] mb-4" /> : vehicleChassis && (
                                        <div className="mt-1 text-size-14 text-gray-500">Chassi - {vehicleChassis}</div>
                                    )}
                                    {loading ? <SkeletonBlock className="h-[10px] w-[200px] mb-4" /> : (vehicleOdometer || vehicleHourmeter) && (
                                        <div className="mt-1 text-size-14 text-gray-500">
                                            {vehicleOdometer && `Odômetro: ${vehicleOdometer}`}
                                            {vehicleOdometer && vehicleHourmeter && ' | '}
                                            {vehicleHourmeter && `Horímetro: ${vehicleHourmeter}`}
                                        </div>
                                    )}
                                    {loading ? <SkeletonBlock className="h-[10px] w-[200px] mb-4" /> : contractNumber && (
                                        <div className="mt-1 font-bold">
                                            {intl.formatMessage({ id: 'intl-msg:budgets.volksTotalPrev' })}: {contractNumber}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* {props.vehicleData?.inWarranty && (
                                        <span className="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-size-12 font-bold whitespace-nowrap mt-1">
                                            Em garantia
                                        </span>
                                    )} */}
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex-1 flex flex-col">
                <div className="mb-2  text-gray-600 text-size-13">{intl.formatMessage({ id: 'intl-msg:budgets.customer' })}</div>
                <div className="border border-gray-200 rounded-md p-4 h-full">
                    <div className="text-size-14 h-full">
                        <div className="text-size-13 text-gray-900 mb-2">{loading ? <SkeletonBlock className="h-[10px] w-[200px] mb-4" /> : customer}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};